import { lockScrollPage } from '../helpers/lockPage';

export function initHeader() {
  return {
    isOpen: false,
    activeSubMenu: null,
    activeMenu: null,
    init() {
      this.$watch('isOpen', value => {
        lockScrollPage(value)
      })
    },
    toggleMenu() {
      if  (this.isOpen) {
        this.activeSubMenu = null
      }

      this.isOpen = !this.isOpen
    },
  }
}
